import './heading.scss'
import clsx from 'clsx'

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
    children: React.ReactNode
    className?: string
}

export const Heading = ({ children, className, ...props }: HeadingProps) => {
    return (
        <h3 className={clsx('heading', className)} {...props}>
            {children}
        </h3>
    )
}
